import { styled } from "@mui/material/styles";
// Add VisibilityIcon to common components when DXB-9467 is done
import VisibilityIcon from "@mui/icons-material/Visibility";
// Add VisibilityOffIcon to common components when DXB-9467 is done
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export const StyledVisibilityIcon = styled(VisibilityIcon)({
  "&:hover": {
    cursor: "pointer"
  }
});

export const StyledVisibilityOffIcon = styled(VisibilityOffIcon)({
  "&:hover": {
    cursor: "pointer"
  }
});
